import React from 'react'
import {
  TextField,
  Button,
  Stack,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material'
import { useForm, Controller } from 'react-hook-form'
import { validationRules } from 'utils/validationRules'
import { api } from 'index'
import { toast } from 'react-toastify'

const RestorePage = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: '',
    },
  })

  const theme = useTheme()

  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'))

  const [done, setDone] = React.useState(false)

  const onSubmit = async ({ email }) => {
    try {
      await api.auth.restore({ email })
      setDone(true)
    } catch (e) {
      toast.error(e.response?.data?.errors?.[0]?.message || 'Ошибка восстановления пароля')
    }
  }

  return (
    <>
      {!done ? (
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Typography
            variant="h2"
            color="text.primary"
            sx={{
              textAlign: 'center',
              marginBottom: `${isLargeScreen ? '4rem' : '3.2rem'}`,
            }}
          >
            Восстановление пароля
          </Typography>

          <Stack sx={{ gap: `${isLargeScreen ? '4rem' : '3.2rem'}` }}>
            <Typography
              variant="legendCaption"
              color="text.primary"
              sx={{ textAlign: 'center' }}
            >
              Введите почту, указанную при регистрации
            </Typography>

            <Controller
              name="email"
              control={control}
              rules={validationRules.email}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Электронная почта"
                  type="email"
                  error={!!errors.email}
                  helperText={errors.email?.message || ' '}
                  fullWidth
                  required
                  slotProps={{
                    input: {
                      style: {
                        background: theme.vars.palette.inputBackground,
                        borderRadius: '12px',
                      },
                    },
                  }}
                />
              )}
            />

            <Button
              type="submit"
              variant="contained"
              sx={{ width: '21.6rem', alignSelf: 'center' }}
            >
              Отправить
            </Button>
          </Stack>
        </form>
      ) : (
        <Stack
          sx={{
            gap: `${isLargeScreen ? '4rem' : '3.2rem'}`,
          }}
        >
          <Typography
            variant="h2"
            color="text.primary"
            sx={{ textAlign: 'center' }}
          >
            Спасибо!
          </Typography>
          <Typography
            variant="legendCaption"
            color="text.primary"
            sx={{ textAlign: 'center' }}
          >
            Пароль отправлен на вашу электронную почту
          </Typography>
          <Button
            href="/"
            variant="contained"
            sx={{ width: '21.6rem', alignSelf: 'center' }}
          >
            Вернуться на главную
          </Button>
        </Stack>
      )}
    </>
  )
}

export default RestorePage
